import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Loading from './Loading';
import Success from './Success';
import SuccessRecurring from './SuccessRecurring';
import Error from './Error';

const Processing = ({
  loading,
  success,
  closeCallback,
  retryCallback,
  isRecurring,
  setBundleBuySuccess,
}) => {
  const getComponent = () => {
    let component = null;
    if (loading) {
      component = <Loading />;
    } else if (success && isRecurring) {
      component = <SuccessRecurring buttonHandler={closeCallback} />;
    } else if (success) {
      component = <Success buttonHandler={closeCallback} />;
    } else {
      component = <Error buttonHandler={retryCallback} />;
    }
    return component;
  };

  useEffect(() => {
    if (success) {
      setBundleBuySuccess(true);
    } else {
      setBundleBuySuccess(false);
    }
  }, [success]);
  return getComponent();
};

Processing.defaultProps = {
  success: false,
};

Processing.propTypes = {
  loading: PropTypes.bool.isRequired,
  succcess: PropTypes.bool,
  closeCallback: PropTypes.func.isRequired,
  retryCallback: PropTypes.func.isRequired,
  setBundleBuySuccess: PropTypes.func.isRequired,
};

export default Processing;
